module.exports = __webpack_public_path__ + "static/media/markowitz-services.8f5ae811.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/markowitz-services.gif
// module id = 29
// module chunks = 0